<router-outlet></router-outlet>
<p-confirmDialog header="Confirmación" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-toast></p-toast>
<app-loader></app-loader>
